<template>
    <app-admin-layout>
        <Head>
            <title>Produzent</title>
        </Head>
        <form @submit.prevent="submit">
            <div class="producer-user">
                <div class="producer-user--header" v-sticky>
                    <description-group>
                        <description-element :caption="form?.prod_no" title="Produzenten-Nr"/>
                        <description-element :caption="form?.company" title="Firma"/>
                        <description-element :caption="form?.name" title="Name"/>
                        <description-element :caption="form?.email" title="Email"/>
                        <description-element :caption="producerUser?.status ? 'aktiv' : 'deaktiviert'" title="Status"/>
                    </description-group>
                </div>
                <div class="producer-user--content">
                    <div class="container">
                        <div class="row"  v-if="!producerUser?.status">
                            <div class="col">
                                <card class="warning">
                                    <card-content>
                                        <strong>Produzent ist nicht aktiv:</strong> Der Account des Produzent ist aktuell deaktiviert.
                                    </card-content>
                                </card>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-6">
                                <card>
                                    <card-header>
                                        <card-overline>Stammdaten</card-overline>
                                    </card-header>
                                    <card-content>
                                        <form-input id="prod_no" label="Produzenten-Nr" v-model="form.prod_no"
                                                    :error="form.errors.prod_no" disabled="true"/>
                                        <form-input id="company" label="Firma" v-model="form.company"
                                                    :error="form.errors.company"/>
                                        <form-input id="name" label="Name" v-model="form.name"
                                                    :error="form.errors.name"/>
                                        <form-group>
                                            <form-input id="street" label="Straße" v-model="form.street"
                                                        :error="form.errors.street" class="three-four"/>
                                            <form-input id="street_no" label="Nr" v-model="form.street_no"
                                                        :error="form.errors.street_no" class="one-four"/>
                                        </form-group>
                                        <form-group>
                                            <form-input id="zip" label="Plz" v-model="form.zip" :error="form.errors.zip"
                                                        class="one-four"/>
                                            <form-input id="city" label="Ort" v-model="form.city"
                                                        :error="form.errors.city"
                                                        class="three-four"/>
                                        </form-group>
                                        <form-select id="producer_country_id" label="Land" :options="producerCountries"
                                                     v-model="form.producer_country_id"
                                                     :error="form.errors.producer_country_id"/>
                                        <form-input id="vat_id" label="USt-Id." v-model="form.vat_id"
                                                    :error="form.errors.vat_id"/>
                                        <form-input id="website" label="Webseite" v-model="form.website"
                                                    :error="form.errors.website"/>
                                        <form-select id="language" label="Sprache" v-model="form.language"
                                                     :options="$page.props.languages"
                                                     :error="form.errors.language"/>
                                        <form-input id="phone" label="Festnetz" v-model="form.phone"
                                                    :error="form.errors.phone"/>
                                        <form-input id="mobile" label="Mobil" v-model="form.mobile"
                                                    :error="form.errors.mobile"/>
                                        <form-checkbox id="send_report" label="Report" option="Report erhalten"
                                                       v-model:checked="form.send_report"/>
                                    </card-content>
                                </card>
                            </div>
                            <div class="col col-6">
                                <div class="row">
                                    <div class="col">
                                        <card>
                                            <card-header>
                                                <card-overline>Produzentenstatus</card-overline>
                                            </card-header>
                                            <card-content>
                                                <table class="table table--card table--th-middle">
                                                    <tr>
                                                        <th style="width: 120px;">Status:</th>
                                                        <td>
                                                            <strong v-if="producerUser?.status"
                                                                    class="text-success">aktiv</strong>
                                                            <strong v-if="!producerUser?.status"
                                                                    class="text-error">deaktiviert</strong>
                                                            <strong v-if="producerUser?.paused" class="text-error">
                                                                (Account pausiert)</strong>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>Letzter Login:</th>
                                                        <td>{{ producerUser?.last_login ? $dateTime(producerUser.last_login) : '-' }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Login-IP:</th>
                                                        <td>{{ producerUser?.last_login_ip }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Stückzahl <br>min - max:</th>
                                                        <td>{{ producerUser?.min_amount ?  producerUser?.min_amount : 'k.A.' }} - {{ producerUser?.max_amount ?  producerUser?.max_amount : 'k.A.' }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>keine Anfrage <br>von - bis:</th>
                                                        <td>{{ producerUser?.no_requests_from ? $date(producerUser?.no_requests_from) : '' }} - {{ producerUser?.no_requests_till ? $date(producerUser?.no_requests_till) : '' }}</td>
                                                    </tr>
                                                </table>
                                            </card-content>
                                        </card>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col col-3">
                                        <card>
                                            <card-header>
                                                <card-overline>Wareneingang</card-overline>
                                            </card-header>
                                            <card-content class="status-card">
                                                <div class="trend">
                                                    <span class="headline-5 headline-5--success">{{ qualityRate }}</span>
                                                    <svg-vue icon="arrow-right" class="icon"/>
                                                </div>
<!--                                                <description-group>-->
<!--                                                    <description-element caption="-->
<!--                                                    {98,7%}" title="Reference"/>-->
<!--                                                    <description-element caption="{98,5%}" title="Current"/>-->
<!--                                                </description-group>-->
                                            </card-content>
                                        </card>
                                    </div>
                                    <div class="col col-3">
                                        <card>
                                            <card-header>
                                                <card-overline>Anfragebearbeitung</card-overline>
                                            </card-header>
                                            <card-content class="status-card">
                                                <div class="trend">
                                                    <span class="headline-5 headline-5--success">{{ activityRate }}</span>
                                                    <svg-vue icon="arrow-right" class="icon"/>
                                                </div>
<!--                                                <description-group>-->
<!--                                                    <description-element caption="{98,7%}" title="Reference"/>-->
<!--                                                    <description-element caption="{98,5%}" title="Current"/>-->
<!--                                                </description-group>-->
                                            </card-content>
                                        </card>
                                    </div>
                                    <div class="col col-3">
                                        <card>
                                            <card-header>
                                                <card-overline>Pünktlichkeit</card-overline>
                                            </card-header>
                                            <card-content class="status-card">
                                                <div class="trend">
                                                    <span class="headline-5 headline-5--success">{{ punctualityRate }}</span>
                                                    <svg-vue icon="arrow-right" class="icon"/>
                                                </div>
<!--                                                <description-group>-->
<!--                                                    <description-element caption="{98,7%}" title="Reference"/>-->
<!--                                                    <description-element caption="{98,5%}" title="Current"/>-->
<!--                                                </description-group>-->
                                            </card-content>
                                        </card>
                                    </div>
                                    <div class="col col-3">
                                        <card>
                                            <card-header>
                                                <card-overline>Reklamationsrate</card-overline>
                                            </card-header>
                                            <card-content class="status-card">
                                                <div class="trend">
                                                    <span class="headline-5 headline-5--success">{{ complaintRate }}</span>
                                                    <svg-vue icon="arrow-right" class="icon"/>
                                                </div>
<!--                                                <description-group>-->
<!--                                                    <description-element caption="{98,7%}" title="Reference"/>-->
<!--                                                    <description-element caption="{98,5%}" title="Current"/>-->
<!--                                                </description-group>-->
                                            </card-content>
                                        </card>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <card>
                                            <card-header>
                                                <card-overline>Account</card-overline>
                                            </card-header>
                                            <card-content>
                                                <form-input id="email" label="Email" v-model="form.email"
                                                            :error="form.errors.email"/>
                                            </card-content>
                                            <div class="row">
                                                <div class="col col-4" v-if="producerUser">
                                                    <form-button type="button" color="secondary" class="btn--block"
                                                                 icon="button-arrow-right-circle"
                                                                 @click="inviteProducer">
                                                        Einladung versenden
                                                    </form-button>
                                                </div>
                                                <div class="col col-4" v-if="producerUser">
                                                    <form-button type="button" color="error" class="btn--block"
                                                                 v-if="producerUser?.status"
                                                                 icon="button-arrow-right-circle"
                                                                 @click="disableProducer">
                                                        Account deaktivieren
                                                    </form-button>
                                                    <form-button type="button" color="secondary" class="btn--block"
                                                                 v-if="!producerUser?.status"
                                                                 icon="button-arrow-right-circle"
                                                                 @click="disableProducer">
                                                        Account aktivieren
                                                    </form-button>
                                                </div>
                                                <div class="col col-4" v-if="producerUser">
                                                    <form-button type="button" color="error" class="btn--block"
                                                                 v-if="!producerUser?.paused"
                                                                 icon="button-arrow-right-circle"
                                                                 @click="pauseProducer">
                                                        Account pausieren
                                                    </form-button>
                                                    <form-button type="button" color="secondary" class="btn--block"
                                                                 v-if="producerUser?.paused"
                                                                 icon="button-arrow-right-circle"
                                                                 @click="pauseProducer">
                                                        Account pausierung aufheben
                                                    </form-button>
                                                </div>
                                            </div>
                                        </card>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <card>
                                            <card-header>
                                                <card-overline>Kommentar zum Produzenten</card-overline>
                                            </card-header>
                                            <card-content>
                                                <form-text id="comment" label="Kommentar" v-model="form.comment"
                                                           :error="form.errors.comment"></form-text>
                                            </card-content>
                                        </card>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <card>
                                    <card-header>
                                        <card-overline>
                                            <translate>Fertigungskapazitäten</translate>
                                        </card-overline>
                                    </card-header>
                                    <card-content>
                                        <div class="row">
                                            <div class="col-6">
                                                <p><strong><translate>Nur Anfragen mit Stückzahlen im Bereich:</translate></strong></p>
                                                <form-group>
                                                    <form-input id="min_amount" :label="this.$gettext('von')" class="one-half" v-model="form.min_amount" :error="form.errors.min_amount" />
                                                    <form-input id="max_amount" :label="this.$gettext('bis')" class="one-half" v-model="form.max_amount" :error="form.errors.max_amount" />
                                                </form-group>
                                            </div>
                                            <div class="col-6">
                                                <p><strong><translate>Ausgelastet / Betriebsferien. Keine Anfragen im Zeitraum:</translate></strong></p>
                                                <form-group>
                                                    <form-datepicker id="no_requests_from" :label="this.$gettext('von')" class="one-half" v-model:date="form.no_requests_from" :error="form.errors.no_requests_from" allow-holidays="true" allow-weekends="true" />
                                                    <form-datepicker id="no_requests_till" :label="this.$gettext('bis')" class="one-half" v-model:date="form.no_requests_till" :error="form.errors.no_requests_till" allow-holidays="true" allow-weekends="true" />
                                                </form-group>
                                            </div>
                                        </div>
                                    </card-content>
                                </card>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <producer-abilities :producerUser="producerUser"
                                                    :abilities="abilities"
                                                    v-model="form.abilities"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="producer-user--footer" v-sticky>
                    <div class="container">
                        <div class="row">
                            <div class="col">
                                <form-actions>
                                    <form-button type="submit" color="secondary"
                                                 icon="button-arrow-right-circle"
                                                 class="btn--block" :disabled="form.processing" :class="{'btn--processing': form.processing}">
                                        Speichern
                                    </form-button>
                                </form-actions>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </app-admin-layout>
</template>

<script>
import AppAdminLayout from '@partfactory/Layouts/AppAdminLayout';
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import {useForm} from '@inertiajs/vue3';
import CardContent from '@partfactory/Shared/Card/CardContent';
import FormInput from '@partfactory/Shared/Form/FormInput';
import FormGroup from '@partfactory/Shared/Form/FormGroup';
import FormCheckbox from '@partfactory/Shared/Form/FormCheckbox';
import FormButton from '@partfactory/Shared/Form/FormButton';
import FormSelect from '@partfactory/Shared/Form/FormSelect';
import DescriptionGroup from '@partfactory/Shared/Elements/DescriptionGroup';
import ProducerAbilities from '@partfactory/Shared/Producer/ProducerAbilities';
import FormActions from '@partfactory/Shared/Form/FormActions';
import FormText from '@partfactory/Shared/Form/FormText';
import DescriptionElement from '@partfactory/Shared/Elements/DescriptionElement';
import FormDatepicker from '@partfactory/Shared/Form/FormDatepicker.vue';

export default {
    name: 'ProducerUser',
    components: {
        FormDatepicker,
        DescriptionElement,
        FormText,
        FormActions,
        ProducerAbilities,
        DescriptionGroup,
        FormSelect,
        FormButton,
        FormCheckbox,
        FormGroup,
        FormInput,
        CardContent,
        CardOverline,
        CardHeader,
        Card,
        AppAdminLayout
    },
    props: {
        'producerUser': Object,
        'producerCountries': Object,
        'abilities': Object,
    },
    data() {
        console.log(this?.producerUser);
        // _token: usePage().props.value.csrf_token
        const form = useForm({
            'prod_no': this?.producerUser?.prod_no,
            'email': this?.producerUser?.email,
            'company': this?.producerUser?.company,
            'name': this?.producerUser?.name,
            'department': this?.producerUser?.department,
            'street': this?.producerUser?.street,
            'street_no': this?.producerUser?.street_no,
            'zip': this?.producerUser?.zip,
            'city': this?.producerUser?.city,
            'producer_country_id': this?.producerUser?.producer_country_id,
            'phone': this?.producerUser?.phone,
            'mobile': this?.producerUser?.mobile,
            'website': this?.producerUser?.website,
            'vat_id': this?.producerUser?.vat_id,
            'language': this?.producerUser?.language,
            'comment': this?.producerUser?.comment,
            'send_report': this?.producerUser ? !!this?.producerUser?.send_report : true,
            'abilities': !!this?.producerUser?.abilities,
            'min_amount': this?.producerUser?.min_amount,
            'max_amount': this?.producerUser?.max_amount,
            'no_requests_from': this?.producerUser?.no_requests_from,
            'no_requests_till': this?.producerUser?.no_requests_till,
        });
        return {form};
    },
    methods: {
        submit() {
            if (this?.producerUser?.prod_no) {
                this.form
                    .transform(data => ({
                        ...data,
                        send_report: this.form.send_report ? '1' : '0',
                        _token: this.$page.props.csrf_token,
                    }))
                    .patch(this.$route('admin.producer-user.update', {'producerUser': this.producerUser.id}), {
                        onError: () => {
                            let errorElement = document.querySelector('.form-element--error')?.getBoundingClientRect();
                            if (errorElement) {
                                const container = document.querySelector('.sidebar--content');
                                container.scrollTo(
                                    (errorElement.left + container.scrollLeft),
                                    (errorElement.top + container.scrollTop) - 76
                                );
                            }
                        }
                    });
            } else {
                this.form
                    .transform(data => ({
                        ...data,
                        send_report: this.form.send_report ? '1' : '0',
                        _token: this.$page.props.csrf_token,
                    }))
                    .post(this.$route('admin.producer-user.store'), {
                        onError: () => {
                            let errorElement = document.querySelector('.form-element--error')?.getBoundingClientRect();
                            if (errorElement) {
                                const container = document.querySelector('.sidebar--content');
                                container.scrollTo(
                                    (errorElement.left + container.scrollLeft),
                                    (errorElement.top + container.scrollTop) - 76
                                );
                            }
                        }
                    });
            }
        },
        inviteProducer() {
            this.$inertia.post(this.$route('admin.producer-user.invite', {'producerUser': this.producerUser.id}));
        },
        disableProducer() {
            this.$inertia.patch(this.$route('admin.producer-user.disable', {'producerUser': this.producerUser.id}));
        },
        pauseProducer() {
            this.$inertia.patch(this.$route('admin.producer-user.pause', {'producerUser': this.producerUser.id}));
        },
    },
    updated() {
        this.form.prod_no = this.producerUser?.prod_no;
    },
    computed: {
        qualityRate() {
            return this.producerUser?.quality_rate ? parseFloat(this.producerUser?.quality_rate).toFixed(2).replace('.', ',') + '%' : 'k.A.';
        },
        punctualityRate() {
            return this.producerUser?.punctuality_rate ? parseFloat(this.producerUser?.punctuality_rate).toFixed(2).replace('.', ',') + '%' : 'k.A.';
        },
        activityRate() {
            return this.producerUser?.activity_rate ? parseFloat(this.producerUser?.activity_rate).toFixed(2).replace('.', ',') + '%' : 'k.A.';
        },
        complaintRate() {
            return this.producerUser?.complaint_rate ? parseFloat(this.producerUser?.complaint_rate).toFixed(2).replace('.', ',') + '%' : 'k.A.';
        },
    }

};
</script>
